<h1 mat-dialog-title class="card-titulo">Cambio de Clave</h1>

<div mat-dialog-content>

  <form [formGroup]="formGroup">

    <div fxLayout="row stretch" fxLayout.xs="column">

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label class="text-label">Clave actual</mat-label>
          <input class="text-label" matInput [type]="hideClaveActual ? 'password' : 'text'" formControlName="ClaveActual" (keyup.enter)="onGuardar()">
          <button mat-icon-button matSuffix (click)="hideClaveActual = !hideClaveActual" type="button"><mat-icon>{{hideClaveActual ? 'visibility_off' : 'visibility'}}</mat-icon></button>
          <mat-error *ngIf="!formGroup.controls['ClaveActual'].valid && formGroup.controls['ClaveActual'].touched">
            {{ getErrorClaveActual() }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label class="text-label">Nueva Clave</mat-label>
          <input class="text-label" matInput [type]="hideClaveNueva ? 'password' : 'text'" formControlName="ClaveNueva" (keyup.enter)="onGuardar()">
          <button mat-icon-button matSuffix (click)="hideClaveNueva = !hideClaveNueva" type="button"><mat-icon>{{hideClaveNueva ? 'visibility_off' : 'visibility'}}</mat-icon></button>
          <mat-error *ngIf="!formGroup.controls['ClaveNueva'].valid && formGroup.controls['ClaveNueva'].touched">
            {{ getErrorClaveNueva() }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label class="text-label">Confirmación de Clave</mat-label>
          <input class="text-label" matInput [type]="hideConfirmClave ? 'password' : 'text'" formControlName="ConfirmClave" (keyup.enter)="onGuardar()">
          <button mat-icon-button matSuffix (click)="hideConfirmClave = !hideConfirmClave" type="button"><mat-icon>{{hideConfirmClave ? 'visibility_off' : 'visibility'}}</mat-icon></button>
          <mat-error *ngIf="!formGroup.controls['ConfirmClave'].valid && formGroup.controls['ConfirmClave'].touched">
            {{ getErrorConfirmClave() }}
          </mat-error>
        </mat-form-field>
      </div>

    </div>

  </form>

</div>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="primary" [disabled]="!buttonEnabled" (click)="onGuardar()" style="margin-right: 5px;">{{buttonEnabled ? 'Confirmar' : 'Confirmando...'}}</button>
    <button mat-raised-button color="warn" (click)="onCancelar()" [disabled]="!buttonEnabled">Cancelar</button>
  </div>
</div>